module.exports = __webpack_public_path__ + "img/3.1_Russian_road_sign.16e36cf6.svg";